<template>
  <div>
    <div>
      <button @click="resetFile" class="gd-default-btn">
        Changer de document (Ré-initialise les champs)
      </button>
    </div>
    <div class="gd-file-viewer__layout">
      <i class="loader loader--medium" v-if="loadingFile"></i>
      <vue-cropper
        v-else
        ref='cropper'
        :guides=true
        :view-mode=1
        :auto-crop=autoCrop
        :auto-crop-area=0.05
        :min-container-width=250
        :min-container-height=180
        :background=true
        :rotatable=false
        :src="image.src"
        alt="Source Image"
        :img-style="{'width': image.width, 'height': image.height}"
        :cropmove="this.cropImage"
        :toggle-drag-mode-on-dblclick=false
        :movable=true
        :zoomable=true
        class="gd-lad-view__file-img">
      </vue-cropper>
      <div id="the-canvas-container" hidden></div>
      <div class="gd-file-viewer__tip" v-if="!loadingFile">
        <IconTip class="gd-file-viewer__tip-icon"></IconTip> Scrollez pour zoomer
      </div>
    </div>
    <div class="gd-text-center">
      <paginate
        name="pagination"
        :list="pages"
        :per="1"
        limit="2"
        ref="paginator"></paginate>
      <paginate-links
        class="gd-pagination gd-pagination--button"
        for="pagination"
        :hide-single-page="true"
        :simple="{
          prev: 'Précédent',
          next: 'Suivant'
        }"
        @change="onPageLoad"></paginate-links>
      <span v-if="$refs.paginator && !loadingFile" class="gd-pagination__page-count">
          {{ $refs.paginator.currentPage + 1 }} sur
          {{ $refs.paginator.lastPage }} page(s)
        </span>
    </div>
  </div>
</template>

<script>

import VueCropper from 'vue-cropperjs';
import VuePaginate from 'vue-paginate';
import IconTip from '@/assets/svg/icon-tips.svg';
import { eventBus } from '../main';

export default {
  name: 'file-viewer',
  props: {
    image: {
      type: Object,
      default: () => ({
        src: '',
        imgCrop: '',
        croppedLocation: {},
        width: '',
        height: '',
      }),
    },
    autoCrop: Boolean,
  },

  components: {
    IconTip,
    VueCropper,
    VuePaginate,
  },

  created() {
    eventBus.$on('resetCroppedArea', () => {
      this.unBuildCropper();
      this.$parent.image.croppedLocation = {};
    });
  },

  data() {
    return {
      pages: [],
      paginate: ['pagination'],
      renderer: {},
      loadingFile: false,
    };
  },

  methods: {
    resetFile() {
      this.loadingFile = true;
      this.$parent.resetFile();
    },

    buildCropper() {
      // rebuild cropper
      this.$refs.cropper.setDragMode('crop');
    },

    unBuildCropper() {
      if (this.$refs.cropper) {
        this.$refs.cropper.reset();
      }
    },

    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.image.croppedLocation = this.$refs.cropper.getData(true);
      this.image.imgCrop = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },

    onPageLoad(toPage) {
      this.renderPage(toPage);
    },
    cropIt(a) {
      // this.$refs.cropper.startCrop();
      const b = Object.assign({}, a);
      b.rotate = 0;
      /*
      const e = document.createEvent('HTMLEvents');
      e.initEvent('cropmove', false, true);
      document.querySelector('div[class="gd-lad-view__file-img"]').dispatchEvent(e);
      */

      // console.log(`croping ${JSON.stringify(b)}`);
      // this.$refs.cropper.setCropBoxData({ left: 0, top: 0, width: 10, height: 10 });

      this.$refs.cropper.setData(b);
      this.cropImage();
    },
    renderPage(pageNumber) {
      const fileViewerVue = this;
      const currentRender = fileViewerVue.renderer[pageNumber - 1];
      const task = currentRender.page.render(currentRender.render);
      const canvas = document.getElementById(currentRender.canvasId);

      fileViewerVue.$parent.currenPdfPage = pageNumber;

      task.promise.then(() => {
        fileViewerVue.image.src = canvas.toDataURL('image/jpeg');
        if (fileViewerVue.$refs.cropper) {
          fileViewerVue.$refs.cropper.replace(fileViewerVue.image.src);
        }
        fileViewerVue.unBuildCropper();
        this.loadingFile = false;
      });
    },

    setImageSrc(pdf) {
      const fileViewerVue = this;
      const canvasContainer = document.getElementById('the-canvas-container');
      for (let i = 1; i <= pdf.numPages; i += 1) {
        // pour la pagination
        fileViewerVue.pages.push(i);

        // chargement des pages du PDF
        pdf.getPage(i).then((page) => {
          const viewport = page.getViewport(1);
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          const id = `canvas-${i}`;

          canvas.setAttribute('id', id);
          fileViewerVue.image.height = `${viewport.height}px`;
          fileViewerVue.image.width = `${viewport.width}px`;
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          canvasContainer.appendChild(canvas);
          fileViewerVue.renderer[page.pageIndex] =
                  { page, canvasId: id, render: { canvasContext: context, viewport } };

          // charger la 1ere page dans le cropper
          if (i === 1) {
            fileViewerVue.renderPage(1);
          }
        });
      }
    },
  },

  mounted() {
    this.loadingFile = true;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FileViewer.vue